import { pageHref } from '../util/pageHref.js'
import { getLang } from '../util/i18n.js'
import { getFooterTexts } from '../data/footerTexts.js'

class SamtFooter extends HTMLElement {
  connectedCallback() {
    this.render()
  }

  render() {
    const lang = getLang()
    const t = getFooterTexts(lang).links
    const copyright = getFooterTexts(lang).copyright

    this.innerHTML = `
    <footer class="flex min-h-64 w-full flex-col items-start bg-black">
      <div
        class="footer-values bg-samt via-samt relative flex min-h-48 w-full flex-col place-items-center gap-8 lg:px-16 pt-8 pb-10 lg:pl-32 lg:items-start lg:justify-start lg:gap-0"
      >
        <img src="/our-value.svg" class="h-auto w-full lg:w-2/5 object-cover" />
        <div
          class="absolute bottom-0 left-0 h-26 max-h-full w-full bg-gradient-to-b from-transparent to-black/30"
        ></div>
      </div>

      <div
        class="footer-main flex lg:min-h-144 min-h-118 w-full flex-col items-center gap-8 border-t-gray-500 px-6 text-center lg:gap-0 lg:px-24 lg:flex-row lg:items-center lg:justify-between lg:text-left"
      >
        <div class="footer-logo w-full pt-8 lg:self-start lg:w-auto lg:pt-36">
          <a href="/" class="mx-auto flex h-18 w-40 items-center justify-center sm:h-22 sm:w-56 lg:mx-0 lg:justify-center">
            <img
              id="samt-footer-logo"
              src="/src/assets/svg/web-SAMT-negative.svg"
              alt="samt"
              class="hover:cursor-pointer"
            />
          </a>
        </div>

        <div
          class="footer-links flex h-full w-full flex-col items-center justify-start lg:w-auto lg:items-start lg:justify-start"
        >
          <!-- 两列网格：第一行为链接，第二行为品牌 Logo 与二维码，列宽共享以保证上下左对齐 -->
          <div
            class="grid w-full grid-cols-2 gap-x-6 gap-y-10 text-sm/6 sm:w-auto sm:grid-cols-[auto_auto] sm:gap-y-16 sm:text-lg/8 lg:gap-x-16 lg:gap-y-24"
          >
            <div class="link-touch g-8 flex flex-col items-start gap-3 border-l text-white border-l-gray-500 pl-4 lg:border-none lg:pl-0 text-left sm:items-start sm:gap-4 lg:gap-0 lg:text-xl/10">
              <span>${t.getInTouch}</span>
              <a href="${pageHref('contact-us')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300"
                >${t.contactUs}</a
              >
              <a href="${pageHref('contact-us')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300"
                >${t.customerSupport}</a
              >
              <a href="${pageHref('about-us')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300"
                >${t.aboutSamt}</a
              >
              <a href="${pageHref('career')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300">${t.joinUs}</a>
            </div>

            <div class="link-touch g-8 flex flex-col items-start text-white gap-3 border-l border-l-gray-500 pl-4 lg:border-none lg:pl-0 text-left sm:items-start sm:gap-4 lg:gap-0 lg:text-xl/10">
              <span>${t.siteInformation}</span>
              <a href="${pageHref('site-map')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300">${t.siteMap}</a>
              <a href="${pageHref('legal-terms')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300"
                >${t.legalTerms}</a
              >
              <a href="${pageHref('downloads')}" class="lg:text-lg/8 text-gray-500 hover:text-gray-300">${t.downloads}</a>
            </div>

            <!-- 关联品牌：云厂与 MSE AI，两者等高，与第一列链接左对齐 -->
            <div class="flex flex-col items-start gap-3 border-l border-transparent pl-4 sm:gap-4 lg:border-none lg:pl-0">
              <a
                href="https://www.yunplant.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="flex max-w-full"
              >
                <img
                  id="samt-footer-brand"
                  src="/src/assets/svg/web-yunplant.svg"
                  alt="yunplant"
                  class="h-5 w-auto max-w-full object-contain object-left hover:cursor-pointer sm:h-9"
                />
              </a>
              <a
                href="https://mse.samtc.com"
                target="_blank"
                rel="noopener noreferrer"
                class="flex max-w-full"
              >
                <img
                  id="samt-footer-ai-logo"
                  src="/src/assets/svg/mse-ai.svg"
                  alt="MSE AI"
                  class="h-5 w-auto max-w-full object-contain object-left hover:cursor-pointer sm:h-9"
                />
              </a>
            </div>

            <!-- 微信服务号二维码，与第二列链接左对齐；sm 以上高度与左侧两个 Logo 总高一致 -->
            <div class="flex flex-col items-center gap-2 justify-self-start border-l border-transparent pl-4 lg:border-none lg:pl-0">
              <img
                id="samt-footer-wechat-qrcode"
                src="/src/assets/svg/wechat_qrcode.jpg"
                alt="微信服务号二维码"
                class="h-20 w-20 rounded bg-white object-cover sm:h-22 sm:w-22"
              />
              <span class="text-xs text-gray-400">微信服务号</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-full border-t border-t-gray-500 pt-[px] pb-4 text-center text-xs/4 lg:text-base/8"
      >
        <p class="text-gray-400">
          ${copyright}
        </p>
      </div>
    </footer>
    `

    // 设置 logo 资源路径，兼容 Vite 构建
    const logoImg = this.querySelector('#samt-footer-logo')
    if (logoImg) {
      try {
        logoImg.src = new URL(
          '../../assets/svg/web-SAMT-negative.svg',
          import.meta.url
        ).href
      } catch (e) {
        // 兜底：如果解析失败，保持原样（方便开发环境观察问题）
        console.warn('[SamtFooter] logo 资源解析失败：', e)
      }
    }

    const brandImg = this.querySelector('#samt-footer-brand')
    if (brandImg) {
      try {
        brandImg.src = new URL(
          '../../assets/svg/web-yunplant.svg',
          import.meta.url
        ).href
      } catch (e) {
        // 兜底：如果解析失败，保持原样（方便开发环境观察问题）
        console.warn('[SamtFooter] brand 资源解析失败：', e)
      }
    }

    // 设置 MSE AI 与微信二维码资源路径，兼容 Vite 构建
    const aiLogoImg = this.querySelector('#samt-footer-ai-logo')
    if (aiLogoImg) {
      try {
        aiLogoImg.src = new URL(
          '../../assets/svg/mse-ai.svg',
          import.meta.url
        ).href
      } catch (e) {
        console.warn('[SamtFooter] AI logo 资源解析失败：', e)
      }
    }

    const wechatQrcodeImg = this.querySelector('#samt-footer-wechat-qrcode')
    if (wechatQrcodeImg) {
      try {
        wechatQrcodeImg.src = new URL(
          '../../assets/svg/wechat_qrcode.jpg',
          import.meta.url
        ).href
      } catch (e) {
        console.warn('[SamtFooter] 微信二维码资源解析失败：', e)
      }
    }
  }
}

customElements.define('samt-footer', SamtFooter)
